import baseURL from "../common/axios";

class CampService {
  GetCampData(SiteId, HospitalId, BranchId, RequestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Camp/GetCampData?SiteId=" + SiteId + "&HospitalId=" + HospitalId + "&BranchId=" + BranchId + "&RequestId=" + RequestId
    );
  }
}

export default new CampService();
